module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAAWCAMAAAAYXScKAAAAAXNSR0IB2cksfwAAADNQTFRFAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAowVGyQAAABF0Uk5TAKQL7xCoy/zOwSs08kExFgFSF0cRAAAAL0lEQVR4nGNggANGJgYsgJll6IqyssEAOweMxcnAxQ0DPLwwFt+gcC81RfkF4EwA1awCENGgMngAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/mpd-library/assets/plus.png
// module id = 882
// module chunks = 0